<template>
  <div class="main-layout main-layout_fullpage">
    <tab-chat class="mb-30" :active="isActive" @changeView="changeView" />

    <div class="chat__wrapper">
      <div class="chat__messages">
        <!-- CHAT DIALOGS START-->
        <dialogs-list
          v-if="dialogs && dialogs.length > 0"
          :clearDialog="isChatTabChanged"
          @dialogChanged="dialogChanged"
          @getDialog="getDialog"
          @openCommonDialog="openCommonDialog"
        />
        <!-- CHAT DIALOGS END-->

        <component
          :is="list"
          :class="{
            'chat-message_open': order != null && order.hasOwnProperty('id'),
          }"
        />
      </div>
      <div
        class="user chat-aclearDialogpplication"
        v-if="order != null && order.hasOwnProperty('id')"
      >
        <orders-modal :large="false" @closeOrderModal="closeOrderModal" />
      </div>
      <modal :show="showModalDelete" :dark="true" @close="toggleDeleteModal">
        <delete-modal
          :title="$t('calendar.deleteTitle')"
          @cancel="toggleDeleteModal"
          @next="removeAction"
        />
      </modal>
      <!-- USER'S A LAST ORDER END-->
    </div>
  </div>
</template>

<script>
import TabChat from '@/components/controls/tabChat'

import DialogsList from '@/components/chat/dialogs-list'
import MessagesList from '@/components/chat/messages-list'
import commonList from '@/components/chat/common-list'
import ordersModal from '@/components/modals/orders/ordersModal'

import { mapMutations, mapGetters, mapActions } from 'vuex'
import store from '../store'

export default {
    components: {
        TabChat,
        DialogsList,
        MessagesList,
        commonList,
        ordersModal,
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== 'orders') {
            this.setOrder(null)
        }

        this.clearParams()
        this.clearOrders()
        next()
    },
    data() {
        return {
            selectSettingServices: {
                placeholder: this.$t('global.serviceHolder'),
                allowClear: false,
            },
            search: '',
            selectData: '',
            list: 'messages-list',
            showModalDelete: false,
            isChatTabChanged: false,
        }
    },
    watch: {
        isliveUpdate(v) {
            if (this.socketDialogIdGetters === this.currentDialogGetters && v) {
                this.getDialog(this.socketDialogIdGetters)
                this.setIsliveUpdate(false)
            }
        },
    },
    computed: {
        ...mapGetters({
            client: 'clientGetters',
            params: 'orders/paramsGetters',
            orders: 'orders/ordersGetters',
            order: 'orders/orderGetters',

            services: 'servicesGetters',
            // chat
            companionName: 'companionNameGetters',
            companionPhoto: 'companionPhotoGetters',
            // admin
            notifications: 'notificationsGetters',
            currentDialogGetters: 'currentDialogGetters',
            socketDialogIdGetters: 'socketDialogIdGetters',
            isliveUpdate: 'isliveUpdate',
        }),
        dialogId: {
            get() {
                return this.$store.state.chat.currentDialog
            },
            set(id) {
                this.$store.state.chat.currentDialog = id
            },
        },
        isActive: {
            get() {
                return this.$store.state.chat.typeDialogs
            },
            set(type) {
                this.$store.state.chat.typeDialogs = type
            },
        },
        dialogs() {
            return this.$store.state.chat.dialogs
        },
    },
    methods: {
        ...mapMutations({
            toggleUpdateCount: 'toggleUpdateCount',
            setParams: 'orders/setParams',
            setSort: 'orders/setSort',
            setOrder: 'orders/setOrder',
            RESET_CURRENT_DIALOG: 'RESET_CURRENT_DIALOG',
            setIsliveUpdate: 'setIsliveUpdate',
            clearOrders: 'orders/clearOrders',
            clearParams: 'orders/clearParams',
            setToggleModalState: 'orders/setToggleModalState',
        }),
        ...mapActions({
            fetchClientById: 'fetchById',
            fetch: 'orders/fetch',
            fetchOrder: 'orders/fetchById',
            clearMessagesList: 'clearMessagesList',
            updateRequestDetails: 'updateRequestDetails',
            deleteRequest: 'deleteRequest',
            sendRequestInvoice: 'sendRequestInvoice',
        }),
        async updateRequest(id, data) {
            await this.updateRequestDetails({ id, data })
            this.sendInvoice(id, data)
        },
        async sendInvoice(id, data) {
            if (data.paymnet_type !== undefined) {
                await this.sendRequestInvoice(id)
            }
        },
        selectService({ id }) {
            this.selectData = id
        },
        changeView(view) {
            this.search = ''
            this.dialogId = ''
            this.selectData = ''
            this.$store.dispatch('clearMessagesList')
            this.getCompanionList(view)
        },
        searchData(search) {
            this.search = search
        },

        getCompanionList(type) {
            this.$Progress.start()
            store
                .dispatch('getDialogs', type)
                .then(() => {
                    this.$Progress.finish()
                    this.isActive = type
                    this.isChatTabChanged = true
                })
                .catch((err) => console.log(err))
        },
        readNotification(dialogNotifications) {
            return new Promise((resolve, reject) => {
                if (dialogNotifications === undefined) {
                    reject()
                }

                this.$store.dispatch('readNotification', dialogNotifications)

                setTimeout(() => {
                    resolve('finished reading')
                }, 2500)
            })
        },
        async getLastOrder(id) {
            if (this.isActive !== 'clients') {
                this.setOrder(null)
                return
            }

            await this.fetchClientById(id)

            this.params.search = this.client.email
            this.setParams(this.params)
            this.setSort({
                sortBy: '&sortedBy=desc',
                orderBy: '&orderBy=shouldStartedAt',
            })
            await this.fetch({ page: 1, isFilter: true })

            if (this.orders === null) {
                this.setOrder(null)
                return
            }
            if (this.orders.length === 0) {
                this.setOrder(null)
                return
            }

            const lastOrderId = this.orders[0].id
            await this.fetchOrder(lastOrderId)

            this.$nextTick(() => {
                this.setToggleModalState(true)
            })
        },
        async getDialog(id) {
            const dialogNotifications = this.notifications.filter((e) => {
                if (e.type === 'message' && e.items[0].client_id !== undefined) {
                    return e.items[0].client_id === id
                } else if (e.type === 'message' && e.items[0].master_id !== undefined) {
                    return e.items[0].master_id === id
                }
            })

            this.dialogId = id
            this.$Progress.start()

            this.getLastOrder(id)

            await store.dispatch('getDialog', {
                type: this.isActive,
                dialogId: this.dialogId,
            })
            this.$Progress.finish()

            this.setList('messages-list')

            if (dialogNotifications && dialogNotifications.length !== 0) {
                const newMessagesId = dialogNotifications.reduce((accum, item) => {
                    accum.push(item.items[0].id)
                    return accum
                }, [])

                await this.readNotification(newMessagesId)
            }

            await store.dispatch('getNotification')
            this.toggleUpdateCount()
        },
        openCommonDialog() {
            this.setList('common-list')
            this.dialogId = 'all'
        },
        setList(v) {
            this.list = v
        },
        toggleDeleteModal() {
            this.showModalDelete = !this.showModalDelete
        },
        async removeAction() {
            await this.deleteRequest(this.id)
            this.toggleDeleteModal()
            this.getLastOrder(this.dialogId)
        },
        dialogChanged() {
            this.setOrder(null)
            this.isChatTabChanged = false
        },
        closeOrderModal() {
            this.setOrder(null)
        },
    },
    beforeMount() {
        this.setOrder(null)
    },
    async destroyed() {
        await this.clearMessagesList()
        this.RESET_CURRENT_DIALOG()
        this.setToggleModalState(false)
    },
    async created() {
        if (this.$route.params.type === undefined) {
            await store.dispatch('getDialogs', 'masters')
            return
        }

        await store.dispatch('getDialogs', this.$route.params.type)
        await store.dispatch('getDialog', {
            type: this.$route.params.type,
            dialogId: this.$route.params.id,
        })
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.user {
  width: 37%;
  padding: 0 !important;
  height: auto;
  overflow-y: auto;

  &-profile {
    display: flex;
    justify-content: space-around;
    align-items: center;

    img {
      background-position: center;
      background-size: cover;
      border: 1px solid #fcee21;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 16px;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }
  }
}

.chat {
  padding: 36px 64px 60px !important;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  height: auto;

  &__box {
    height: auto;
  }

  &__name {
    font-size: 16px;
    margin-top: 8px;
    font-weight: bold;
  }
}

.chat {
  padding: 36px 64px 60px !important;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  height: auto;

  &__box {
    height: auto;
  }

  &__wrapper {
    position: relative;
    width: 100%;
    height: calc(100vh - 103px);
    display: flex;
    justify-content: space-between;
  }

  &__messages {
    display: flex;
    width: 100%;
  }

  &__nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;

    & .select {
      margin-left: 15px;
      margin-right: 15px;
      max-width: 240px;
      @include respond(desktop) {
        min-width: 190px !important;
        max-width: 190px;
      }
    }
  }
}
</style>

<style>
.chat-application .application {
  width: 100% !important;
  margin: 0 auto;
}

.chat-application .application__button {
  padding: 0 20px !important;
}

.chat-application .application__body {
  padding: 0 16px 24px !important;
}
</style>
